<app-side-menu>
  <div class="contract-view-container cv-shell">
    <!-- Cabeçalho escuro (referência visual) -->
    <header class="cv-header">
      <button type="button" class="cv-header-btn cv-header-btn-ghost" (click)="navigateBack()">
        <i class="fas fa-arrow-left"></i>
        Voltar
      </button>

      <div class="cv-header-center">
        <div class="cv-header-title-row">
          <i class="fas fa-file-contract cv-header-icon"></i>
          <h1 class="cv-header-title">Visualizar Contrato</h1>
        </div>
        <p class="cv-header-sub">
          Detalhes completos do contrato #{{ contractId ? contractId.toString().padStart(4, '0') : '0000' }}
        </p>
      </div>

      <div class="cv-header-actions contract-view-header-menu">
        <div
          *ngIf="contractShowsHeaderActionsMenu()"
          class="actions-menu-container cv-header-menu-wrap">
          <button
            type="button"
            class="cv-header-btn cv-header-btn-ghost cv-header-btn-icon"
            [class.active]="showContractHeaderMenu"
            (click)="toggleContractHeaderMenu($event)"
            title="Mais opções">
            <i class="fas fa-ellipsis-vertical"></i>
          </button>
          <div *ngIf="showContractHeaderMenu" class="actions-dropdown" (click)="$event.stopPropagation()">
            <button
              *ngIf="contractAllowsFreeze() && !contractAllowsUnfreeze()"
              type="button"
              class="dropdown-item"
              (click)="openFreezeModalFromHeader()">
              <i class="fas fa-snowflake"></i>
              <span>Congelar contrato</span>
            </button>
            <button
              *ngIf="contractAllowsUnfreeze()"
              type="button"
              class="dropdown-item"
              (click)="confirmUnfreezeFromHeader()">
              <i class="fas fa-sun"></i>
              <span>Descongelar contrato</span>
            </button>
          </div>
        </div>
      </div>
    </header>

    <app-loading [show]="isLoading" [message]="processingStatus || 'Carregando detalhes do contrato...'"></app-loading>

    <div *ngIf="!isLoading && contract" class="cv-main">
      <!-- 1. Informações gerais -->
      <section class="cv-card">
        <div class="cv-card-head">
          <i class="fas fa-file-contract cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Informações Gerais</h2>
        </div>
        <div class="cv-card-body">
          <div class="cv-grid-2">
            <div class="cv-field">
              <span class="cv-label">Número do Contrato</span>
              <span class="cv-value cv-value-strong-lg">#{{ contractId ? contractId.toString().padStart(4, '0') : '0000' }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Status</span>
              <span class="cv-pill" [ngClass]="getCvContractStatusPillModifier(contract.status)">
                {{ getStatusLabel(contract.status) }}
              </span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Valor base</span>
              <span class="cv-value cv-value-strong-lg">{{ formatPrice(contract.baseAmount) }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Caução</span>
              <span class="cv-value cv-value-strong-lg">{{ formatPrice(contract.depositAmount) }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Ciclo de cobrança</span>
              <span class="cv-value">{{ contract.billingCycle || '-' }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Data de criação</span>
              <span class="cv-value">{{ formatDate(contract.createdAt) }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Auditoria: cancellationHistory / lastCancellation* / _erpContractCancelHistory -->
      <section class="cv-card cv-card-cancel-audit" *ngIf="isContractCancelledView()">
        <div class="cv-card-head cv-card-head-cancel">
          <i class="fas fa-ban cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Motivo do cancelamento</h2>
        </div>
        <div class="cv-card-body" *ngIf="erpContractCancel as ca">
          <div class="cv-grid-2">
            <div class="cv-field cv-span-2">
              <span class="cv-label">Último motivo registrado</span>
              <span class="cv-value cv-cancel-motivo">{{ ca.motivo }}</span>
            </div>
            <div class="cv-field" *ngIf="ca.cancelledAtUtc">
              <span class="cv-label">Registrado em</span>
              <span class="cv-value">{{ formatCancelledAtDisplay(ca.cancelledAtUtc) }}</span>
            </div>
          </div>

          <div class="cv-cancel-history" *ngIf="cancellationHistoryView.length > 1">
            <h3 class="cv-cancel-history-title">Histórico de cancelamentos</h3>
            <div class="cv-table-wrap">
              <table class="cv-table cv-cancel-history-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Motivo</th>
                    <th>Data (UTC)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of cancellationHistoryView; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.motivo }}</td>
                    <td>{{ row.cancelledAtUtc ? formatCancelledAtDisplay(row.cancelledAtUtc) : '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="cv-card-body" *ngIf="!erpContractCancel">
          <p class="cv-cancel-missing mb-0">
            Nenhum motivo foi encontrado nos dados do contrato. O cancelamento pode ter ocorrido antes da gravação
            automática do motivo ou os dados ainda não foram sincronizados.
          </p>
        </div>
      </section>

      <!-- Cliente -->
      <section class="cv-card" *ngIf="customer">
        <div class="cv-card-head">
          <i class="fas fa-building cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Dados do Cliente</h2>
        </div>
        <div class="cv-card-body">
          <div class="cv-grid-2">
            <div class="cv-field">
              <span class="cv-label">Nome</span>
              <span class="cv-value cv-value-strong">{{ customer.name || '-' }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Documento</span>
              <span class="cv-value">{{ customer.document || customer.documentNumber || '-' }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">E-mail</span>
              <span class="cv-value">{{ customer.email || '-' }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Telefone</span>
              <span class="cv-value">{{ customer.phone || '-' }}</span>
            </div>
            <div class="cv-field cv-span-2" *ngIf="customer.address">
              <span class="cv-label">Endereço</span>
              <span class="cv-value">
                {{ customer.address.street }}, {{ customer.address.number }}
                <span *ngIf="customer.address.complement"> — {{ customer.address.complement }}</span><br />
                {{ customer.address.district }} — {{ customer.address.city }}/{{ customer.address.state }}<br />
                CEP: {{ customer.address.zipCode }}
              </span>
            </div>
          </div>
        </div>
      </section>

      <!-- Motorista -->
      <section class="cv-card" *ngIf="driver">
        <div class="cv-card-head">
          <i class="fas fa-user cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Dados do Motorista</h2>
        </div>
        <div class="cv-card-body">
          <div class="cv-grid-2">
            <div class="cv-field">
              <span class="cv-label">Nome completo</span>
              <span class="cv-value cv-value-strong">{{ driver.name }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">CPF/CNPJ</span>
              <span class="cv-value">{{ driver.cpfCnpj }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">CNH</span>
              <span class="cv-value">{{ driver.cnhNumber }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Validade CNH</span>
              <span class="cv-value">{{ formatDate(driver.cnhExpiryDate) }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">E-mail</span>
              <span class="cv-value">{{ driver.email }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Telefone</span>
              <span class="cv-value">{{ driver.phone }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Veículo -->
      <section class="cv-card" *ngIf="vehicleDisplay">
        <div class="cv-card-head">
          <i class="fas fa-motorcycle cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Dados do Veículo</h2>
        </div>
        <div class="cv-card-body">
          <div class="cv-grid-2">
            <div class="cv-field">
              <span class="cv-label">Placa</span>
              <span class="cv-plate">{{ vehicleDisplay.plate }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Modelo</span>
              <span class="cv-value cv-value-strong">{{ vehicleDisplay.brand }} {{ vehicleDisplay.model }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Ano</span>
              <span class="cv-value">{{ vehicleDisplay.year }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Cor</span>
              <span class="cv-value">{{ vehicleDisplay.color }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">RENAVAM</span>
              <span class="cv-value">{{ vehicleDisplay.renavam }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Chassi</span>
              <span class="cv-value">{{ vehicleDisplay.chassis }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Quilometragem</span>
              <span class="cv-value">{{ vehicleDisplay.currentKm != null ? (vehicleDisplay.currentKm | number) + ' km' : '-' }}</span>
            </div>
            <div class="cv-field" *ngIf="vehicleDisplay.status">
              <span class="cv-label">Status</span>
              <span class="cv-pill cv-pill-info">{{ vehicleDisplay.status }}</span>
            </div>
            <div class="cv-field" *ngIf="vehicleDisplay.category">
              <span class="cv-label">Categoria</span>
              <span class="cv-value">{{ vehicleDisplay.category }}</span>
            </div>
            <div class="cv-field" *ngIf="vehicleDisplay.fuelType">
              <span class="cv-label">Combustível</span>
              <span class="cv-value">{{ vehicleDisplay.fuelType }}</span>
            </div>
            <div class="cv-field" *ngIf="vehicleDisplay.engineCapacity">
              <span class="cv-label">Cilindrada</span>
              <span class="cv-value">{{ vehicleDisplay.engineCapacity }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Período -->
      <section class="cv-card">
        <div class="cv-card-head">
          <i class="fas fa-calendar-alt cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Período do Contrato</h2>
        </div>
        <div class="cv-card-body">
          <div class="cv-grid-2">
            <div class="cv-field">
              <span class="cv-label">Data de início</span>
              <span class="cv-value">{{ formatDate(contract.startDate) }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Data de término</span>
              <span class="cv-value">{{ formatDate(contract.endDate) }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Duração</span>
              <span class="cv-value">{{ summary.contractDuration || 0 }} dias</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Dias restantes</span>
              <span class="cv-value" [class.cv-value-danger]="(summary.daysRemaining || 0) < 30">
                {{ summary.daysRemaining || 0 }} dias
              </span>
            </div>
          </div>
        </div>
      </section>

      <!-- Produto + pagamentos -->
      <section class="cv-card" *ngIf="product">
        <div class="cv-card-head">
          <i class="fas fa-box cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Produto / Plano</h2>
        </div>
        <div class="cv-card-body">
          <div class="cv-grid-2">
            <div class="cv-field">
              <span class="cv-label">Nome</span>
              <span class="cv-value cv-value-strong">{{ product.name }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Código</span>
              <span class="cv-value">{{ product.code }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Ciclo</span>
              <span class="cv-value">{{ product.billingCycle }}</span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Preço base</span>
              <span class="cv-value cv-value-strong">{{ formatPrice(product.basePrice) }}</span>
            </div>
            <div class="cv-field cv-span-2" *ngIf="product.description">
              <span class="cv-label">Descrição</span>
              <span class="cv-value">{{ product.description }}</span>
            </div>
          </div>

          <div class="cv-subsection">
            <h3 class="cv-subsection-title">
              <i class="fas fa-credit-card cv-subsection-icon"></i>
              Status de pagamentos
            </h3>
            <div class="cv-pay-row">
              <div class="cv-pay-block">
                <span class="cv-label">Caução paga</span>
                <div class="cv-pay-actions">
                  <span class="cv-pill" [class.cv-pill-success]="contract.depositPaid" [class.cv-pill-neutral]="!contract.depositPaid">
                    {{ contract.depositPaid ? 'Sim' : 'Não' }}
                  </span>
                  <button
                    *ngIf="!contract.depositPaid"
                    type="button"
                    class="cv-btn cv-btn-emerald"
                    (click)="confirmDepositPayment()"
                    [disabled]="isLoading">
                    <i class="fas fa-check-circle"></i>
                    Confirmar pagamento
                  </button>
                  <button
                    *ngIf="contract.depositPaid"
                    type="button"
                    class="cv-btn cv-btn-outline-primary"
                    (click)="navigateDepositRefund()"
                    title="Registrar devolução da caução como conta a pagar">
                    <i class="fas fa-undo-alt"></i>
                    Devolução de caução
                  </button>
                </div>
              </div>
              <div class="cv-pay-block" *ngIf="contract.depositPaidDate">
                <span class="cv-label">Data pagamento caução</span>
                <span class="cv-value">{{ formatDate(contract.depositPaidDate) }} {{ formatTime(contract.depositPaidDate) }}</span>
              </div>
              <div class="cv-pay-block">
                <span class="cv-label">1ª parcela paga</span>
                <div class="cv-pay-actions">
                  <span class="cv-pill" [class.cv-pill-success]="contract.firstInstallmentPaid" [class.cv-pill-neutral]="!contract.firstInstallmentPaid">
                    {{ contract.firstInstallmentPaid ? 'Sim' : 'Não' }}
                  </span>
                  <button
                    *ngIf="!contract.firstInstallmentPaid"
                    type="button"
                    class="cv-btn cv-btn-emerald"
                    (click)="confirmFirstInstallmentPayment()"
                    [disabled]="isLoading">
                    <i class="fas fa-check-circle"></i>
                    Confirmar pagamento
                  </button>
                </div>
              </div>
              <div class="cv-pay-block" *ngIf="contract.firstInstallmentPaidDate">
                <span class="cv-label">Data pagamento 1ª parcela</span>
                <span class="cv-value">{{ formatDate(contract.firstInstallmentPaidDate) }} {{ formatTime(contract.firstInstallmentPaidDate) }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Contas a Receber + Asaas (espelho do módulo financeiro) -->
      <section class="cv-card" *ngIf="contract">
        <div class="cv-card-head">
          <i class="fas fa-money-check-dollar cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Títulos e cobranças (Contas a Receber)</h2>
        </div>
        <div class="cv-card-body">
          <app-contract-accounts-receivable-panel
            [contractId]="contractId"
            [customerId]="contract.customerId"
            [contractNumber]="contract.contractNumber"
            [readOnly]="true">
          </app-contract-accounts-receivable-panel>
        </div>
      </section>

      <!-- Checklist -->
      <section class="cv-card" *ngIf="contract">
        <div class="cv-card-head">
          <i class="fas fa-clipboard-check cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Checklist de saída do veículo</h2>
        </div>
        <div class="cv-card-body">
          <div class="cv-checklist-row" *ngIf="contract.checklistPerformed === true || contract.checklistId">
            <div class="cv-field">
              <span class="cv-label">Status</span>
              <span class="cv-pill cv-pill-success">
                <i class="fas fa-check-circle"></i>
                Realizado
              </span>
            </div>
            <div class="cv-field" *ngIf="contract.checklistId">
              <span class="cv-label">Ação</span>
              <button type="button" class="cv-btn cv-btn-slate" (click)="navigateToChecklist(contract.checklistId)">
                <i class="fas fa-eye"></i>
                Visualizar checklist
              </button>
            </div>
            <div class="cv-field" *ngIf="contract.checklistPerformedDate">
              <span class="cv-label">Data de realização</span>
              <span class="cv-value">{{ formatDate(contract.checklistPerformedDate) }} {{ formatTime(contract.checklistPerformedDate) }}</span>
            </div>
          </div>
          <div class="cv-checklist-row" *ngIf="!(contract.checklistPerformed === true || contract.checklistId)">
            <div class="cv-field">
              <span class="cv-label">Status</span>
              <span class="cv-pill cv-pill-amber-strong">
                <i class="fas fa-exclamation-circle"></i>
                Não realizado
              </span>
            </div>
            <div class="cv-field">
              <span class="cv-label">Ação</span>
              <button type="button" class="cv-btn cv-btn-slate" (click)="createAndGoToChecklist()">
                <i class="fas fa-pen"></i>
                Criar e preencher checklist
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- Versionamento -->
      <div class="cv-docs-outer" *ngIf="pendingDocumentToShow || signedDocuments.length > 0">
        <div class="cv-docs-heading">
          <i class="fas fa-history cv-docs-heading-icon"></i>
          <h2 class="cv-docs-heading-title">Versionamento de Documentos</h2>
        </div>

        <div class="cv-docs-badges" *ngIf="documentsSummary || product">
          <span class="cv-badge cv-badge-emerald" *ngIf="documentsSummary">Assinados: {{ getSignedDocumentsCount() }}</span>
          <span class="cv-badge cv-badge-amber" *ngIf="pendingDocumentToShow">Pendente: {{ pendingDocumentToShow.versaoFormatada }}</span>
          <span class="cv-badge cv-badge-slate" *ngIf="documentsSummary">Última versão: v{{ documentsSummary.ultimaVersao }}</span>
          <span class="cv-badge cv-badge-slate-light" *ngIf="product && product.code">
            Produto: {{ product.code | slice:0:28 }}<ng-container *ngIf="product.code.length > 28">…</ng-container>
          </span>
        </div>

        <div class="cv-version-stat-grid" *ngIf="documentsResumo">
          <div class="cv-version-stat">
            <span class="cv-version-stat-label"><i class="fas fa-list-ol"></i> Total de versões</span>
            <span class="cv-version-stat-value">{{ documentsResumo.totalVersoes }}</span>
          </div>
          <div class="cv-version-stat">
            <span class="cv-version-stat-label"><i class="fas fa-check-circle"></i> Versões assinadas</span>
            <span class="cv-version-stat-value cv-version-stat-value-emerald">
              {{ getSignedDocumentsCount() }}
              <span class="cv-version-stat-sub" *ngIf="signedDocuments.length > 0">({{ getSignedVersionsList() }})</span>
            </span>
          </div>
          <div class="cv-version-stat cv-version-stat-highlight">
            <span class="cv-version-stat-label"><i class="fas fa-exclamation-circle"></i> Versão corrente</span>
            <span class="cv-version-stat-value cv-version-stat-value-amber" *ngIf="pendingDocumentToShow">{{ pendingDocumentToShow.versaoFormatada }}</span>
            <span class="cv-version-stat-value" *ngIf="!pendingDocumentToShow && lastSignedDocumentForView">{{ lastSignedDocumentForView.versaoFormatada }}</span>
          </div>
          <div class="cv-version-stat">
            <span class="cv-version-stat-label"><i class="fas fa-redo"></i> Próxima versão</span>
            <span class="cv-version-stat-value">{{ documentsResumo.proximaVersao }}</span>
          </div>
        </div>

        <div *ngIf="contractDocumentsList && contractDocumentsList.length > 0 && signedDocuments.length === 0" class="cv-alert cv-alert-warn cv-mb">
          <i class="fas fa-exclamation-triangle"></i>
          <strong>Atenção:</strong> Existem {{ contractDocumentsList.length }} documento(s), mas nenhum foi identificado como assinado.
        </div>

        <div *ngIf="pendingDocumentToShow" class="cv-pending-banner">
          <div class="cv-pending-banner-text">
            <i class="fas fa-exclamation-circle"></i>
            A versão <strong>{{ pendingDocumentToShow.versaoFormatada }}</strong> está pendente de assinatura.
          </div>
          <div class="cv-pending-banner-actions">
            <button
              *ngIf="(pendingDocumentToShow.podeAssinar && pendingDocumentToShow.isPendente) || (signedDocuments.length === 0 && pendingDocumentToShow.isPendente)"
              type="button"
              class="cv-btn cv-btn-amber"
              (click)="signDocument(pendingDocumentToShow)">
              <i class="fas fa-signature"></i>
              Assinar {{ pendingDocumentToShow.versaoFormatada }}
            </button>
            <button type="button" class="cv-btn cv-btn-dark" (click)="viewDocument(pendingDocumentToShow)">
              <i class="fas fa-eye"></i>
              Visualizar
            </button>
            <button type="button" class="cv-btn cv-btn-neutral-outline" (click)="reloadContractDocuments()">
              <i class="fas fa-sync-alt"></i>
              Atualizar
            </button>
          </div>
        </div>

        <div *ngIf="lastSignedDocumentForView">
          <h3 class="cv-signed-heading">
            <i class="fas fa-check-circle"></i>
            Contrato vigente (último assinado)
          </h3>
          <div *ngIf="lastSignedDocumentForView as doc" class="cv-signed-card">
            <div class="cv-signed-card-head">
              <span class="cv-signed-version-tag"><i class="fas fa-file-word"></i> {{ doc.versaoFormatada }}</span>
              <span class="cv-pill cv-pill-success">Assinado</span>
            </div>
            <h4 class="cv-signed-title">{{ getDocumentTypeLabel(doc.documentType) }}</h4>
            <div class="cv-grid-2 cv-mb-sm">
              <div class="cv-field">
                <span class="cv-label">Criado</span>
                <span class="cv-value">{{ formatDate(doc.createdAt) }}</span>
              </div>
              <div class="cv-field" *ngIf="doc.updatedAt">
                <span class="cv-label">Atualizado</span>
                <span class="cv-value">{{ formatDate(doc.updatedAt) }}</span>
              </div>
            </div>
            <div class="cv-field cv-mb-md" *ngIf="doc.textSummary">
              <span class="cv-label">Resumo</span>
              <p class="cv-value cv-p-summary">{{ doc.textSummary }}</p>
            </div>
            <div class="cv-field cv-mb-md" *ngIf="doc.providerDocumentId">
              <span class="cv-label">ID do documento</span>
              <span class="cv-doc-id">{{ doc.providerDocumentId }}</span>
            </div>
            <div class="cv-field cv-mb-md">
              <span class="cv-label">URL do documento</span>
              <span [class.cv-text-emerald]="doc.storageUrl" [class.cv-text-muted-strong]="!doc.storageUrl">
                {{ doc.storageUrl ? 'Disponível' : 'Não disponível' }}
              </span>
            </div>
            <div class="cv-signed-actions">
              <button type="button" class="cv-btn cv-btn-sky" (click)="viewDocument(doc)" [disabled]="!doc.storageUrl">
                <i class="fas fa-eye"></i>
                Visualizar
              </button>
              <button type="button" class="cv-btn cv-btn-gray" (click)="printDocument(doc)">
                <i class="fas fa-print"></i>
                Imprimir
              </button>
              <button type="button" class="cv-btn cv-btn-emerald" (click)="downloadDocumentFile(doc)">
                <i class="fas fa-download"></i>
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="cv-card" *ngIf="!pendingDocumentToShow && signedDocuments.length === 0 && contractDocumentsList && contractDocumentsList.length === 0">
        <div class="cv-empty-inline">
          <i class="fas fa-file-circle-question"></i>
          <h3>Nenhum documento encontrado</h3>
          <p>Este contrato ainda não possui documentos versionados.</p>
        </div>
      </div>

      <div class="cv-card" *ngIf="(!contractDocumentsList || contractDocumentsList.length === 0) && documents && documents.length > 0">
        <div class="cv-card-head">
          <i class="fas fa-file-pdf cv-card-head-icon"></i>
          <h2 class="cv-card-head-title">Documento do Contrato</h2>
        </div>
        <div class="cv-card-body">
          <div *ngFor="let doc of documents | slice:0:1" class="cv-legacy-doc">
            <div class="cv-legacy-doc-head">
              <h4>{{ doc.documentType }}</h4>
              <span class="cv-pill" [ngClass]="getCvSignaturePillModifier(doc.signatureStatus)">{{ getSignatureStatusLabel(doc.signatureStatus) }}</span>
            </div>
            <div class="cv-legacy-doc-body">
              <p><strong>Provedor:</strong> {{ doc.signatureProvider }}</p>
              <p><strong>Tamanho:</strong> {{ formatFileSize(doc.fileSizeBytes) }}</p>
              <p *ngIf="doc.textSummary"><strong>Resumo:</strong> {{ doc.textSummary }}</p>
              <p><strong>Criado em:</strong> {{ formatDate(doc.createdAt) }}</p>
            </div>
            <div class="cv-signed-actions">
              <button type="button" class="cv-btn cv-btn-sky" (click)="viewDocument(doc)"><i class="fas fa-eye"></i> Visualizar</button>
              <button *ngIf="doc.signatureStatus === 'Pending' || doc.signatureStatus === 'PENDING'" type="button" class="cv-btn cv-btn-amber" (click)="openSignatureModal()">
                <i class="fas fa-signature"></i> Assinar
              </button>
              <button *ngIf="doc.signatureStatus === 'SIGNED' || doc.signatureStatus === 'Signed'" type="button" class="cv-btn cv-btn-gray" (click)="printDocument(doc)">
                <i class="fas fa-print"></i> Imprimir
              </button>
              <button type="button" class="cv-btn cv-btn-emerald" (click)="downloadDocumentFile(doc)"><i class="fas fa-download"></i> Download</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Histórico de ações / auditoria — por último na página (GET .../view/contratos/{id}/acoes) -->
      <section class="cv-card cv-card-actions-log">
        <div class="cv-card-head cv-card-head-actions-log">
          <div class="cv-actions-log-head-left">
            <i class="fas fa-history cv-card-head-icon"></i>
            <div>
              <h2 class="cv-card-head-title mb-0">Histórico de ações</h2>
              <p class="cv-actions-log-sub" *ngIf="!isLoadingContractActions && !contractActionsError">
                {{ contractActionsTotal }} registro(s) — linha do tempo do contrato
              </p>
            </div>
          </div>
          <button
            type="button"
            class="cv-btn cv-btn-neutral-outline cv-btn-sm"
            [disabled]="isLoadingContractActions"
            (click)="loadContractActions()">
            <i class="fas fa-sync-alt" [class.fa-spin]="isLoadingContractActions"></i>
            Atualizar
          </button>
        </div>
        <div class="cv-card-body">
          <div *ngIf="isLoadingContractActions" class="cv-actions-log-loading">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Carregando histórico...</span>
          </div>
          <div *ngIf="!isLoadingContractActions && contractActionsError" class="cv-actions-log-alert">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{ contractActionsError }}</span>
          </div>
          <div
            *ngIf="!isLoadingContractActions && !contractActionsError && contractActionsLog.length === 0"
            class="cv-actions-log-empty">
            <i class="fas fa-inbox"></i>
            <p>Nenhuma ação registrada para este contrato.</p>
          </div>
          <ul *ngIf="!isLoadingContractActions && !contractActionsError && contractActionsLog.length > 0" class="cv-actions-timeline">
            <li
              *ngFor="let action of contractActionsLog; let i = index; trackBy: trackByActionIndex"
              class="cv-actions-timeline-item">
              <div class="cv-actions-timeline-marker">
                <i class="fas" [ngClass]="getContractActionIcon(action.tipoAcao)"></i>
              </div>
              <div class="cv-actions-timeline-card">
                <div class="cv-actions-timeline-card-top">
                  <div class="cv-actions-timeline-title-wrap">
                    <span class="cv-action-pill" [ngClass]="getContractActionCategoryClass(action.categoriaAcao)">
                      {{ getContractActionCategoryLabel(action.categoriaAcao) }}
                    </span>
                    <h3 class="cv-actions-timeline-title">{{ getContractActionDisplayTitle(action) }}</h3>
                  </div>
                  <time class="cv-actions-timeline-time">{{ getContractActionWhen(action) }}</time>
                </div>
                <p class="cv-actions-timeline-resumo" *ngIf="getContractActionDisplayResumo(action) as resumoAcao">{{ resumoAcao }}</p>
                <div class="cv-actions-timeline-meta">
                  <div class="cv-actions-meta-row">
                    <span class="cv-label">Executor</span>
                    <span class="cv-value">{{ getContractActionExecutorLabel(action) }}</span>
                  </div>
                  <div class="cv-actions-meta-row" *ngIf="getContractActionExecutorExtra(action) as extraEmail">
                    <span class="cv-label">E-mail</span>
                    <span class="cv-value">{{ extraEmail }}</span>
                  </div>
                  <div class="cv-actions-meta-row" *ngIf="action.statusAnterior || action.novoStatus">
                    <span class="cv-label">Status</span>
                    <span class="cv-actions-status-flow">
                      <span class="cv-pill cv-pill-neutral cv-pill-xs">{{ action.statusAnterior || '—' }}</span>
                      <i class="fas fa-arrow-right cv-actions-status-arrow"></i>
                      <span class="cv-pill cv-pill-success cv-pill-xs">{{ action.novoStatus || '—' }}</span>
                    </span>
                  </div>
                  <div class="cv-actions-meta-row" *ngIf="shouldShowContractActionEntityRow(action)">
                    <span class="cv-label">Entidade</span>
                    <span class="cv-value">
                      {{ action.tipoEntidadeRelacionada || '—' }}
                      <span *ngIf="action.idEntidadeRelacionada != null" class="cv-actions-entity-id">
                        #{{ action.idEntidadeRelacionada }}
                      </span>
                    </span>
                  </div>
                  <div class="cv-actions-meta-row" *ngIf="action.geradoPorSistema">
                    <span class="cv-label">Origem</span>
                    <span class="cv-value"><i class="fas fa-robot me-1"></i>Gerado pelo sistema</span>
                  </div>
                </div>
                <div class="cv-actions-timeline-expand" *ngIf="hasContractActionExpandableContent(action)">
                  <button
                    type="button"
                    class="cv-btn cv-btn-linkish"
                    (click)="toggleContractActionDetails(i)">
                    <i class="fas fa-chevron-down" [class.cv-chevron-open]="isContractActionExpanded(i)"></i>
                    {{ isContractActionExpanded(i) ? 'Ocultar detalhes técnicos' : 'Ver detalhes técnicos' }}
                  </button>
                  <div class="cv-actions-details-panel" *ngIf="isContractActionExpanded(i)">
                    <ng-container *ngIf="getContractActionDetailSections(action) as detailSections; else contractDetailsRawTpl">
                      <p class="cv-actions-details-intro">
                        <i class="fas fa-layer-group"></i>
                        Detalhes estruturados
                      </p>
                      <div class="cv-actions-details-structured">
                        <div
                          *ngFor="let sec of detailSections"
                          class="cv-actions-detail-subcard"
                          [class.cv-actions-detail-subcard--root]="!sec.title && detailSections.length === 1">
                          <h4 *ngIf="sec.title" class="cv-actions-detail-section-title">{{ sec.title }}</h4>
                          <dl class="cv-actions-detail-dl">
                            <ng-container *ngFor="let row of sec.rows">
                              <dt>{{ row.label }}</dt>
                              <dd [class.cv-actions-detail-multiline]="row.value.indexOf('\n') >= 0">
                                <a
                                  *ngIf="row.isLink"
                                  [href]="row.value"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="cv-actions-detail-link">
                                  {{ row.value }}
                                  <i class="fas fa-external-link-alt cv-actions-detail-link-icon"></i>
                                </a>
                                <ng-container *ngIf="!row.isLink">{{ row.value }}</ng-container>
                              </dd>
                            </ng-container>
                          </dl>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #contractDetailsRawTpl>
                      <div *ngIf="formatContractActionDetailsJson(action) as pretty" class="cv-actions-json-block">
                        <span class="cv-label d-block mb-1">Detalhes (texto bruto)</span>
                        <pre class="cv-actions-json-pre">{{ pretty }}</pre>
                      </div>
                    </ng-template>
                    <div class="cv-actions-meta-row" *ngIf="action.enderecoIp">
                      <span class="cv-label">IP</span>
                      <span class="cv-value">{{ action.enderecoIp }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>

    <!-- Modal visualizador -->
    <div *ngIf="showDocumentViewer" class="document-viewer-overlay" (click)="closeDocumentViewer()">
      <div class="document-viewer-modal" (click)="$event.stopPropagation()">
        <div class="document-viewer-header">
          <h3>
            <i class="fas fa-file-word"></i>
            Visualizar Documento do Contrato
          </h3>
          <button class="btn-close" (click)="closeDocumentViewer()">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="document-viewer-content">
          <div *ngIf="isLoadingDocument" class="document-loading">
            <i class="fas fa-spinner fa-spin"></i>
            <p>Carregando documento...</p>
          </div>
          <div *ngIf="!isLoadingDocument && selectedDocumentUrl" class="document-frame">
            <iframe [src]="getOfficeViewerUrl()" width="100%" height="100%" frameborder="0"></iframe>
          </div>
          <div *ngIf="!isLoadingDocument && !selectedDocumentUrl" class="document-error">
            <i class="fas fa-exclamation-triangle"></i>
            <p>Não foi possível carregar o documento</p>
          </div>
        </div>
        <div class="document-viewer-footer">
          <button class="btn-secondary" (click)="closeDocumentViewer()">
            <i class="fas fa-times"></i>
            Fechar
          </button>
          <div class="document-viewer-actions">
            <button class="btn-primary" (click)="downloadCurrentDocument()">
              <i class="fas fa-download"></i>
              Baixar Documento
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal assinatura -->
    <div *ngIf="showSignatureModal" class="signature-modal-overlay" (click)="closeSignatureModal()">
      <div class="signature-modal" (click)="$event.stopPropagation()">
        <div class="signature-modal-header">
          <h3><i class="fas fa-signature"></i> Assinatura Digital</h3>
          <button class="btn-close" (click)="closeSignatureModal()">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="signature-modal-content">
          <div class="signature-canvas-container">
            <canvas #signatureCanvas class="signature-canvas"></canvas>
          </div>
        </div>
        <div class="signature-modal-footer">
          <button class="btn-clear" (click)="clearSignature()">
            <i class="fas fa-eraser"></i>
            Limpar
          </button>
          <div class="signature-action-buttons">
            <button class="btn-cancel" (click)="closeSignatureModal()">
              <i class="fas fa-times"></i>
              Cancelar
            </button>
            <button class="btn-save-signature" (click)="saveSignature()">
              <i class="fas fa-check"></i>
              Salvar Assinatura
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading && !contract" class="cv-empty-page">
      <i class="fas fa-file-contract"></i>
      <h3>Contrato não encontrado</h3>
      <p>O contrato solicitado não foi encontrado ou não existe.</p>
      <button type="button" class="cv-btn cv-btn-sky" (click)="navigateBack()">
        <i class="fas fa-arrow-left"></i>
        Voltar para lista
      </button>
    </div>

    <app-contract-freeze-modal
      [isOpen]="showFreezeModal"
      [contractId]="contractId"
      [subtitle]="'#' + (contractId ? contractId.toString().padStart(4, '0') : '')"
      (closed)="closeFreezeModal()"
      (frozen)="onContractFrozen($event)">
    </app-contract-freeze-modal>
  </div>
</app-side-menu>
